import React, { useEffect } from 'react';

const RouteDivisionGrid = () => {
  useEffect(() => {
    try {
      new Greenmile.RouteDivisionOrders.Grid().init();
    } catch (e) {
      console.log(e.message);
    }
  }, []);

  return (
    <div id="RouteDivisionGrid">
      <div className="gridActions ui-widget-header" />
      <div className="gridContainer ui-widget" />
    </div>
  );
};

export default RouteDivisionGrid;
